import{_ as e}from"./_getNative.js";var t=e(Object,"create");export{t as _};
